module.exports = __webpack_public_path__ + "static/img/function-8.d7f39f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/function-8.png
// module id = kUeU
// module chunks = 0